export const PROPERTY_TYPE_APPARTAMENTO = 'APPARTAMENTO';
export const PROPERTY_TYPE_VILLA = 'VILLA';
export const PROPERTY_FEATURES_BALCONE_TERRAZZO = 'BALCONE_TERRAZZO';
export const PROPERTY_FEATURES_BOX_AUTO = 'BOX_AUTO';
export const PROPERTY_FEATURES_GIARDINO = 'GIARDINO';
export const PROPERTY_FEATURES_ASCENSORE = 'ASCENSORE';
export const PROPERTY_STATUS_ABITABILE = 'ABITABILE';
export const PROPERTY_STATUS_DA_RISTRUTTURARE = 'DA_RISTRUTTURARE';
export const PROPERTY_STATUS_RISTRUTTURATO = 'RISTRUTTURATO';
export const PROPERTY_STATUS_NUOVO = 'NUOVO';
export const PROPERTY_STATUS_IN_COSTRUZIONE = 'IN_COSTRUZIONE';

export const floorSelectOptions = [
  {
    value: '',
    label: 'Seleziona un piano',
  },
  {
    value: '-0.5',
    label: 'Seminterrato',
  },
  {
    value: '0.0',
    label: 'Terra',
  },
  {
    value: '0.5',
    label: 'Rialzato',
  },
  {
    value: '1',
    label: '1',
  },
  {
    value: '2',
    label: '2',
  },
  {
    value: '3',
    label: '3',
  },
  {
    value: '4',
    label: '4',
  },
  {
    value: '5',
    label: '5',
  },
  {
    value: '6',
    label: '6',
  },
  {
    value: '7',
    label: '7',
  },
  {
    value: '8',
    label: '8',
  },
  {
    value: '9',
    label: '9',
  },
  {
    value: '10',
    label: '10',
  },
  {
    value: '11',
    label: '10+',
  },
];

export const statusSelectOptions = [
  {
    value: PROPERTY_STATUS_ABITABILE,
    label: 'In buono stato',
  },
  {
    value: PROPERTY_STATUS_DA_RISTRUTTURARE,
    label: 'Da ristrutturare',
  },
  {
    value: PROPERTY_STATUS_RISTRUTTURATO,
    label: 'Ristrutturato',
  },
  {
    value: PROPERTY_STATUS_NUOVO,
    label: 'Nuova costruzione',
  },
  {
    value: PROPERTY_STATUS_IN_COSTRUZIONE,
    label: 'In costruzione',
  },
];

export const featuresCheckboxes = [
  {
    type: PROPERTY_FEATURES_BALCONE_TERRAZZO,
    label: 'Balcone/Terrazzo',
  },
  {
    type: PROPERTY_FEATURES_BOX_AUTO,
    label: 'Box auto',
  },
  {
    type: PROPERTY_FEATURES_GIARDINO,
    label: 'Giardino',
  },
  {
    type: PROPERTY_FEATURES_ASCENSORE,
    label: 'Ascensore',
  },
];

export const propertyTypesRadio = [
  {
    value: PROPERTY_TYPE_APPARTAMENTO,
    label: 'Appartamento',
  },
  {
    value: PROPERTY_TYPE_VILLA,
    label: 'Villa',
  },
];
